import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private API_URL = environment.API_URL;

  constructor(private http: HttpClient) { }
  getVideoUrl(page: string){
    let videoUrl = `${this.API_URL}/api/video/stream/1/mp4/Overall_Home`;
    switch (page) {
      case '/ebu/engines/sales-realization/All':
        case '/ebu/engines/sales-realization/industrial':
          case '/ebu/engines/sales-realization/onHighway':
            case '/ebu/engines/sales-realization/powerGen':
        videoUrl = `${this.API_URL}/api/video/stream/1/mp4/Engine_EBU`;
        break;
      case '/distribution/cssna/powerGen/powerGen?filter=':
        case '/distribution/cssna/powerGen/powerGen?filter=parts':
        case '/distribution/cssna/powerGen/powerGen?filter=service':
          case '/distribution/cssna/powerGen/powerGen?filter=wholegoods':
            case '/distribution/cssna/engines/industrial?filter=':
              case '/distribution/cssna/engines/industrial?filter=parts':
              case '/distribution/cssna/engines/industrial?filter=service':
                case '/distribution/cssna/engines/industrial?filter=wholegoods':
                  case '/distribution/cssna/engines/on-highway?filter=':
                    case '/distribution/cssna/engines/on-highway?filter=service':
                      case '/distribution/cssna/engines/on-highway?filter=wholegoods':
        videoUrl = `${this.API_URL}/api/video/stream/1/mp4/CSSNA_Overall`;
        break;
        case '/distribution/international/parts?filter=':
          case '/distribution/international/parts/AME?filter=':
            case '/distribution/international/parts/AME?filter=parts':
              case '/distribution/international/parts/AME?filter=service':
                case '/distribution/international/parts/Arabia-JV?filter=':
                  case '/distribution/international/parts/Arabia-JV?filter=parts':
                    case '/distribution/international/parts/Arabia-JV?filter=service':
                      case '/distribution/international/parts/Asia-Pacific?filter=':
                        case '/distribution/international/parts/Asia-Pacific?filter=parts':
                          case '/distribution/international/parts/Asia-Pacific?filter=service':
                            case '/distribution/international/parts/Asia-Pacific?filter=':
                              case '/distribution/international/parts/Asia-Pacific?filter=parts':
                                case '/distribution/international/parts/Asia-Pacific?filter=service':
                                  case '/distribution/international/parts/East-Asia?filter=':
                                    case '/distribution/international/parts/East-Asia?filter=parts':
                                      case '/distribution/international/parts/East-Asia?filter=service':
                                        case '/distribution/international/parts/Greater-Europe?filter=':
                                          case '/distribution/international/parts/Greater-Europe?filter=parts':
                                            case '/distribution/international/parts/Greater-Europe?filter=service':
                                              case '/distribution/international/parts/India?filter=':
                                                case '/distribution/international/parts/India?filter=parts':
                                                  case '/distribution/international/parts/Latin-America?filter=':
                                                    case '/distribution/international/parts/Latin-America?filter=parts':
                                                      case '/distribution/international/parts/Latin-America?filter=service':
        videoUrl = `${this.API_URL}/api/video/stream/1/mp4/DBU_International`;
        break;
        
        case '/power-systems/engines/sales-realization':
        videoUrl = `${this.API_URL}/api/video/stream/1/mp4/Power_Systems_Engines`;
        break;
        case '/power-systems/power-gen/sales-realization':
        videoUrl = `${this.API_URL}/api/video/stream/1/mp4/Power_Systems_PowerGen`;
         break;
         case '/ebu/parts/ebu':
          case '/components/ctt/parts':
            case '/power-systems/parts/psbu':
        videoUrl = `${this.API_URL}/api/video/stream/1/mp4/NRP_Scorecard`;
        break;
        case '/overall/overall-view':
        videoUrl = `${this.API_URL}/api/video/stream/1/mp4/Overall_Home`;
        break;
      default:
        videoUrl = `${this.API_URL}/api/video/stream/1/mp4/Overall_Home`;
        break;
    }
    
    // if(page.toLowerCase()  === '/power-systems/engines/sales-realization'){
    //   videoUrl = `${this.API_URL}/api/video/stream/1/mp4/vinay`;
    // }else if(page.toLowerCase()  === '/distribution/cssna/powerGen/powerGen?filter='){
    //   videoUrl = `${this.API_URL}/api/video/stream/1/mp4/default`;
    // }
    // else{
    //   videoUrl = `${this.API_URL}/api/video/stream/1/mp4/default1`;

    // }
    return videoUrl;
  }

  public getVersions(){
    return this.http.get(`${this.API_URL + '/sales/realization/latest-dates'}`);
  }
  
}
